import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { memo } from 'react';
import { CATEGORY_VISIBILITY, CATEGORY_VISIBILITY_MAP } from 'modules/inventory/settings/category/constants';
import useCategoryUpdateVisible from 'modules/inventory/settings/category/hooks/useCategoryUpdateVisible';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

type CategoryVisiblePickerProps = {
  value: boolean;
  rowId?: string;
  button?: boolean;
};

const CategoryVisiblePicker = ({ value, rowId, button }: CategoryVisiblePickerProps) => {
  const { t } = useTranslation('category');
  const { updateVisible, isLoading } = useCategoryUpdateVisible(rowId as string);

  return (
     <Box
      sx={{
        '.MuiButton-root': {
          borderRadius: button ? '5px !important' : undefined,
        },
        button: {
          minWidth: 90,
          minHeight: button ? 36.5 : 'auto',
          alignItems: 'center',
          justifyContent: 'space-around',
          'MuiButton-endIcon': {
            marginLeft: '2px !important',
          },
        },
      }}
    >
      <StatusPicker
      options={CATEGORY_VISIBILITY.map((option) => ({ ...option, title: t(option.title) }))}
      name='active'
      size={'small'}
      value={{
        ...(CATEGORY_VISIBILITY_MAP.get(value) as IStatus),
        title: t(CATEGORY_VISIBILITY_MAP.get(value)?.title as string),
      }}
      isLoading={isLoading}
      onChange={() => {
        updateVisible(!value);
      }}
    />
    </Box>
  );
};
export default memo(CategoryVisiblePicker);
